import AppExpired from './AppExpired';

export default AppExpired;
